import { render, staticRenderFns } from "./example_picture.vue?vue&type=template&id=77a03b16"
import script from "./example_picture.vue?vue&type=script&lang=js"
export * from "./example_picture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77a03b16')) {
      api.createRecord('77a03b16', component.options)
    } else {
      api.reload('77a03b16', component.options)
    }
    module.hot.accept("./example_picture.vue?vue&type=template&id=77a03b16", function () {
      api.rerender('77a03b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/display_activity_execution/component/example_picture.vue"
export default component.exports